import { IndeterminateProgressCircle as CssModulesIndeterminateProgressCircle, IndeterminateProgressCircleProps } from '@sunwebgroup/uds-ui/IndeterminateProgressCircle'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/IndeterminateProgressCircle' instead.
 */
export default Object.assign(
  styled(CssModulesIndeterminateProgressCircle)<IndeterminateProgressCircleProps>``,
  { displayName: 'IndeterminateProgressCircle' },
)
